import { render, staticRenderFns } from "./MyPage5.vue?vue&type=template&id=bd50f176&scoped=true"
import script from "./MyPage5.vue?vue&type=script&lang=js"
export * from "./MyPage5.vue?vue&type=script&lang=js"
import style0 from "./MyPage5.vue?vue&type=style&index=0&id=bd50f176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd50f176",
  null
  
)

export default component.exports